import React from "react";

const rows = [
  { label: "Monto del crédito", value: "$1.000.000 CLP" },
  { label: "Plazo", value: "12 meses" },
  { label: "Tasa de interés mensual (referencial)", value: "1,00%" },
  { label: "Cuota mensual estimada", value: "$88.849 CLP" },
  { label: "Total a pagar", value: "$1.066.183 CLP" },
  { label: "Intereses totales estimados", value: "$66.183 CLP" },
  { label: "CAE (Carga Anual Equivalente) estimada", value: "12,68%" },
  { label: "Costo total del crédito", value: "$1.066.183 CLP" },
];

export default function RepresentativeExample() {
  return (
    <section
      id="ejemplo"
      className="py-20 lg:py-28 bg-slate-50 border-y border-slate-200"
      data-testid="representative-example-section"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-blue-600">
            Ejemplo representativo
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Cómo se vería un crédito de $1.000.000 CLP
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            Ejemplo exclusivamente ilustrativo conforme a la normativa de la CMF.
            Los valores reales que te ofrezca una entidad financiera pueden
            variar según tu perfil crediticio.
          </p>
        </div>

        <div className="mt-10 rounded-2xl border-2 border-teal-200 bg-gradient-to-br from-teal-50 to-white overflow-hidden">
          <div className="px-6 sm:px-8 py-5 bg-teal-500/10 border-b border-teal-200">
            <h3 className="text-lg font-bold text-slate-900">
              Crédito de $1.000.000 CLP · 12 meses · 1% mensual referencial
            </h3>
            <p className="text-sm text-slate-600 mt-1">
              Desglose estimado. CAE incluida según ley chilena.
            </p>
          </div>
          <dl className="divide-y divide-slate-200">
            {rows.map((r, i) => (
              <div
                key={i}
                className="px-6 sm:px-8 py-4 flex justify-between items-center gap-4"
                data-testid={`example-row-${i}`}
              >
                <dt className="text-sm text-slate-600">{r.label}</dt>
                <dd className="text-sm sm:text-base font-semibold text-slate-900 text-right">
                  {r.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <p className="mt-6 text-xs text-slate-500 leading-relaxed">
          <strong>Nota:</strong> Ejemplo calculado con sistema francés de cuotas
          fijas y tasa referencial de 1% mensual. Las condiciones finales (tasa,
          CAE, seguros, comisiones y costo total del crédito) son entregadas por
          la entidad financiera que apruebe la solicitud. Plazo mínimo legal
          igual o superior a 61 días.
        </p>
      </div>
    </section>
  );
}
